﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const whitespace = /\s$/;
if (!String.prototype.hasOwnProperty("capitalize")) {
    String.prototype.capitalize = function () {
        return this.split("").reduce((prev, cur, i) => i === 1
            ? prev.toLocaleUpperCase() + cur
            : prev + (whitespace.test(prev) ? cur.toLocaleUpperCase() : cur));
    };
}
